let audioCtx = null
let ultimoTocar = 0

function contexto() {
	const AudioCtx = window.AudioContext || window.webkitAudioContext
	if (!AudioCtx) return null
	if (!audioCtx || audioCtx.state === "closed") audioCtx = new AudioCtx()
	return audioCtx
}

/** Chamar no clique, antes de qualquer espera, para o navegador liberar o áudio. */
export function prepararSomSucesso() {
	const ctx = contexto()
	if (ctx && ctx.state === "suspended") ctx.resume().catch(() => {})
}

function moeda(ctx, master, quando, freq, vol) {
	const n = Math.floor(ctx.sampleRate * 0.018)
	const buf = ctx.createBuffer(1, n, ctx.sampleRate)
	const dados = buf.getChannelData(0)
	for (let i = 0; i < n; i++) {
		const env = (1 - i / n) ** 2
		dados[i] = (Math.random() * 2 - 1) * env
	}
	const src = ctx.createBufferSource()
	src.buffer = buf
	const filtro = ctx.createBiquadFilter()
	filtro.type = "bandpass"
	filtro.frequency.value = freq
	filtro.Q.value = 8
	const gRuido = ctx.createGain()
	gRuido.gain.value = vol * 0.9
	src.connect(filtro)
	filtro.connect(gRuido)
	gRuido.connect(master)
	src.start(quando)

	;[[1, 0.55, 0.11], [2.4, 0.25, 0.06]].forEach(([razao, peso, queda]) => {
		const osc = ctx.createOscillator()
		const ganho = ctx.createGain()
		osc.type = "sine"
		osc.frequency.value = freq * razao
		ganho.gain.setValueAtTime(0.0001, quando)
		ganho.gain.exponentialRampToValueAtTime(vol * peso, quando + 0.004)
		ganho.gain.exponentialRampToValueAtTime(0.0001, quando + queda)
		osc.connect(ganho)
		ganho.connect(master)
		osc.start(quando)
		osc.stop(quando + 0.14)
	})
}

function emitir(ctx) {
	const t0 = ctx.currentTime
	const master = ctx.createGain()
	master.gain.value = 0.85
	master.connect(ctx.destination)

	;[
		[0.00, 3200, 0.22],
		[0.045, 4100, 0.2],
		[0.08, 2800, 0.18],
		[0.12, 4600, 0.2],
		[0.165, 3500, 0.16]
	].forEach(([em, freq, vol]) => moeda(ctx, master, t0 + em, freq, vol))

	const cha = t0 + 0.22
	const nCha = Math.floor(ctx.sampleRate * 0.05)
	const bufCha = ctx.createBuffer(1, nCha, ctx.sampleRate)
	const dadosCha = bufCha.getChannelData(0)
	for (let i = 0; i < nCha; i++) dadosCha[i] = (Math.random() * 2 - 1) * (1 - i / nCha) ** 1.4
	const srcCha = ctx.createBufferSource()
	srcCha.buffer = bufCha
	const grave = ctx.createBiquadFilter()
	grave.type = "lowpass"
	grave.frequency.value = 900
	const gCha = ctx.createGain()
	gCha.gain.value = 0.45
	srcCha.connect(grave)
	grave.connect(gCha)
	gCha.connect(master)
	srcCha.start(cha)

	;[[1568, 0.42, 0.55], [2093, 0.28, 0.7], [3136, 0.08, 0.35]].forEach(([freq, vol, dur]) => {
		const osc = ctx.createOscillator()
		const ganho = ctx.createGain()
		osc.type = "sine"
		osc.frequency.value = freq
		ganho.gain.setValueAtTime(0.0001, cha)
		ganho.gain.exponentialRampToValueAtTime(vol, cha + 0.01)
		ganho.gain.exponentialRampToValueAtTime(0.0001, cha + dur)
		osc.connect(ganho)
		ganho.connect(master)
		osc.start(cha)
		osc.stop(cha + dur + 0.05)
	})
}

/** Moedas e o sino da gaveta. Só na finalização do serviço. */
export function tocarSomSucesso() {
	const agora = Date.now()
	if (agora - ultimoTocar < 500) return
	ultimoTocar = agora

	const ctx = contexto()
	if (!ctx) return
	if (ctx.state === "suspended") {
		ctx.resume().then(() => emitir(ctx)).catch(() => {})
		return
	}
	emitir(ctx)
}
